// extracted by mini-css-extract-plugin
export default {"triggerButton":"NewContentButton_triggerButton__EqWvr","tooltip":"NewContentButton_tooltip__FPC6y","tooltipContainer":"NewContentButton_tooltipContainer__urbvM"};